<template>
  <div class="home">
    <p class="tips">店铺名以小程序中的为准，如下面没有你要下单的店铺，请点击选择地点搜索附近地点</p>
    <div class="search">
<!--      <p v-if="!city.cityName">暂未选择城市</p>-->
<!--      <p v-else>{{city.cityName}}</p>-->
      <el-input v-model="city.title" class="search-ipt" placeholder="请点击选择地点" disabled></el-input>
      <el-button type="primary" @click="getCity" style="margin-left: 20px;background-color: #E60012;border-color:#E60012;">选择地点</el-button>
    </div>
<!--    <div class="choseDrink">-->
<!--      <el-select v-model="cityID" placeholder="请选择城市" @change="changeCity">-->
<!--        <el-option-->
<!--            v-for="item in cityList"-->
<!--            :key="item.itemNo"-->
<!--            :label="item.title"-->
<!--            :value="item.itemNo">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--    </div>-->
<!--    <div class="search" style="margin-top: 20px">-->
<!--      <el-input v-model="shopName" class="search-ipt" placeholder="请输入店铺名"></el-input>-->
<!--      <el-button type="primary" @click="searchShop" style="background-color: #E60012;border-color:#E60012;">搜索</el-button>-->
<!--    </div>-->

    <!--    附近门店-->
    <div>
      <p>附近门店</p>
      <div v-if="shopList.length===0 && !requestFlag" class="noShop">暂无符合门店</div>
      <div v-if="requestFlag" class="noShop">搜索中，请稍等</div>
      <div v-else v-for="item in shopList" :key="item.shopMdCode" @click="changeShop(item)">
        <div :class="[item.operationStatus !==1 ? 'deActive':'','shopItem']">
          <p :class="[item.operationStatus !==1 ? 'deActive':'shopName']">{{ item.shopName }}</p>

          <p v-if="item.operationStatus == 0" class="tag">繁忙置休</p>
          <p v-else-if="item.operationStatus == 1" class="tag active">营业中</p>
          <p v-else style="color: #989898" class="tag">门店休息</p>

          <p>营业时间：{{ item.operationTime }}</p>

          <p class="shopAdd"><span v-if="item.regionName">{{item.regionName}}</span>{{item.shopAddress }}</p>

        </div>
      </div>
    </div>


    <!-- 添加订单提示弹窗 -->
    <el-dialog
        title="订单提示"
        :visible.sync="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
    >
      <span>已下单，是否查看？一个下单链接只能下一杯哦~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goToOrder">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {findNear,queryCard} from "../api/mxbc.js"


export default {
  name: "Location",
  data() {
    return {
      cardID: '',
      location: {
        latitude: '29.705480575561523',
        longitude: '116.00145721435547'
      },
      city:{},
      //cityName: '',
      //cityMdCode: '',
      //cityList: [],
      shopName: '',
      shopList: [],
      requestFlag:false,
      dialogVisible: false  // 添加弹窗控制变量
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID){
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep:true
    }
  },
  mounted() {
    //console.log(this.$route.query.cardID,'this.$route.query.cardID')
    //var that = this
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (this.$route.query.type) {
      //this.type = this.$route.query.type || ""
      const type = this.$route.query.type || ""
      localStorage.setItem('type', type);
    }

    if(JSON.parse(localStorage.getItem('city'))) this.city = JSON.parse(localStorage.getItem('city'))

    // bus.$on('changeCity', data=>{
    //   that.city = JSON.parse(JSON.stringify(data))
    //   // that.cityName = data.cityName
    //   // that.cityMdCode = data.cityMdCode
    //   console.log(that.city,'6666that.cityName')
    //   //that.$forceUpdate();
    // })

    this.AD();
    this.getLocation();

  },
  methods: {
    //获取经纬度
    getLocation() {
      // 如果city中有location数据，直接使用
      if (this.city.location && this.city.location.lat && this.city.location.lng) {
        this.getShopListByLocation();
        return;
      }

      // 检查浏览器是否支持地理定位
      if (!navigator.geolocation) {
        this.$message.error('请选择地点');
        return;
      }

      // 设置超时处理
      // const timeoutId = setTimeout(() => {
      //   this.$message.error('请选择地点');
      // }, 5000); // 5秒超时

      navigator.geolocation.getCurrentPosition(
          (position) => {
            //clearTimeout(timeoutId);
            const lat = String(
                Number(parseFloat(`${position.coords.latitude}`))
            );
            const lng = String(
                Number(parseFloat(`${position.coords.longitude}`))
            );
            this.location.latitude = lat;
            this.location.longitude = lng;
            this.getShopListByLocation();
          },
          (error) => {
            //clearTimeout(timeoutId);
            console.error('定位错误:', error.message);
            this.$message.error('获取定位出错，请选择地点');
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
      );
    },
    //查询卡密
    AD() {
      if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
      let params = {
        cardID: localStorage.getItem('cardID'),
        type:localStorage.getItem('type') || ""
      }
      queryCard(params).then(res => {
        //code如果是0 代表可以下单 不用提示， 1的话 提示用户去查看订单
        //console.log(res, '查询卡密返回')
        //if (res.code !== 0) return this.$message.error(res.msg)
        localStorage.setItem('value', JSON.stringify(res));
        if (res.code == 0 && res.msg =="已下单") this.dialogVisible = true;
      })
    },
    //获取市级城市列表
    getCity() {
      this.$router.push('city')
    },
    //选择市级城市
    // changeCity(city) {
    //   console.log(city,'++++')
    // },
    //城市+关键词搜索店铺列表
    // searchShop() {
    //   if (!this.city.cityMdCode) return this.$message.error('请先选择城市')
    //   let params = {
    //     CityMdCode: this.city.cityMdCode,
    //     shopMdName: this.shopName
    //   }
    //   queryShopsByName(params).then(res => {
    //     //console.log(res, '城市+关键词搜索店铺列表返回')
    //     let data = res.data
    //     this.shopList = data
    //   })
    // },
    changeShop(item) {
      //选择店铺
      if (item.operationStatus !== 1) return this.$message.error('该店闭店中，暂不可选')
      let info = {
        shopName:item.shopName,
        shopID:item.shopId,
        shopCode:item.shopCode
      }
      localStorage.setItem('shopInfo', JSON.stringify(info));
      this.$router.push('/shop')
    },
    getShopListByLocation() {
      this.requestFlag = true;
      let params = {
        latitude: this.location.latitude,
        longitude: this.location.longitude
      };

      // 优先使用city中的位置信息
      if (this.city.location && this.city.location.lat && this.city.location.lng) {
        params.latitude = this.city.location.lat;
        params.longitude = this.city.location.lng;
      }

      // 检查是否有有效的位置信息
      if (!params.latitude || !params.longitude) {
        this.requestFlag = false;
        this.$message.error('请选择地点');
        return;
      }

      // 确保数值类型
      params.latitude = Number(parseFloat(params.latitude));
      params.longitude = Number(parseFloat(params.longitude));

      findNear(params).then(res => {
        console.log(res, '根据经纬度查询店铺返回')
        let data = res.data.data
        this.shopList = data
        this.requestFlag = false
      }).catch(err=>{
        //this.requestFlag = false
      }).finally(()=>{
        this.requestFlag = false
      })

    },
    // 跳转到订单页面
    goToOrder() {
      this.dialogVisible = false;
      this.$router.push('/order');
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  padding: 15px;
  margin-bottom: 60px;
  .search {
    width: 100%;
    margin: 0 auto 20px auto;
    display: flex;
    align-items: center;
    .search-ipt {
      margin-right: 20px;
    }
  }

  .choseDrink {
    width: 100%;
    margin: 20px auto 0 auto;
  }

  .noShop{
    margin: 20px auto;
    text-align: center;
    color: #E60012;
  }

  .shopItem {
    //min-height: 130px;
    border: 1px solid #F6E9EB;
    border-radius: 15px;
    padding: 15px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    //justify-content: space-around;
    color: #636363;
    .shopName{
      font-size: 18px;
      color: #000000;
    }

    .shopAdd {
      margin: 8px 0;
      //color: #636363;
    }
  }
}

.tag{
  width: 60px;
  height: 20px;
  margin: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 5px;
  font-size: 14px;
  background-color: #F5F5F5;
  color: #989898;
  border-radius: 5px;
}

.active{
  background-color: #E60012;
  color: #FFFFFF;
}

.deActive{
  color: rgb(152, 152, 152) !important;
}

.tips{
  font-size: 13px;
  padding: 10px 0;
  color: #999999;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}
</style>